/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import ArrowSvg from "../../../../assets/images/arrow-back.svg";
import ArrowRight from "../../../../assets/images/arrow-right.svg";
import Loading from "../../../components/shared/Loading";
import MessageModal from "../../../components/shared/MessageModal";
import Search from "../../../components/shared/Search";
import ProviderService from "../../../services/ProviderServices";
import "./HomeSelect.scss";

const HomeSelect = ({ title, plate, onBack, onFinish, type, operator }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [textSearch, setTextSearch] = useState("");
  const [modalNoInternet, setModalNoInternet] = useState(false);

  useEffect(() => {
    if (type === 1) {
      setData([]);
      async function fetchData() {
        try {
          setLoading(true);
          const operators = await ProviderService.getOperatorsReturn();
          setData(operators);
          setLoading(false);
        } catch (e) {
          setLoading(false);
          setModalNoInternet(true);
        }
      }
      fetchData();
    } else {
      setData([]);
      async function fetchData() {
        try {
          setLoading(true);
          const pickups = await ProviderService.getPickupsByOp(operator.id);
          console.log("pickups", pickups);
          setData(pickups);
          setLoading(false);
        } catch (e) {
          setLoading(false);
          setModalNoInternet(true);
        }
      }
      fetchData();
    }
  }, [operator?.id, type]);

  const renderOptions = () => {
    const valueToFilter = type === 1 ? "name" : "title";
    const filteredData = data.filter((d) =>
      d[valueToFilter].toUpperCase().includes(textSearch.toUpperCase())
    );

    return filteredData.map((d) =>
      type === 1 ? (
        <Option onClick={() => onFinish(d)} key={d.id}>
          <div className="operator-option-1">
            <img src={d.image} alt="logo" />
            <p>{d.name}</p>
          </div>
        </Option>
      ) : (
        <Option onClick={() => onFinish(d)} key={d.id}>
          <div className="operator-option-2">
            <img src={operator.image} />
            <h2>{d.title}</h2>
            <p>{d.address}</p>
          </div>
        </Option>
      )
    );
  };

  return (
    <>
      <Loading visible={loading} />
      <MessageModal
        visible={modalNoInternet}
        closeModal={() => setModalNoInternet(false)}
        message="No tiene conexión a internet"
        type={2}
      />
      <div className="operator-select-container">
        <div className="operator-select-header">
          <div onClick={() => onBack()}>
            <img src={ArrowSvg} alt="" />
          </div>
          <h2>{title}</h2>
        </div>
        <div className="operator-select-search">
          <Search
            placeholder="Buscar"
            setText={(e) => setTextSearch(e.target.value)}
            text={textSearch}
          />
        </div>
        <div className="operator-select-options">{renderOptions()}</div>
      </div>
    </>
  );
};

const Option = ({ children, onClick }) => {
  return (
    <div className="operator-option-container">
      <div className="operator-option-left">{children}</div>
      <div className="operator-option-right" onClick={() => onClick()}>
        <img src={ArrowRight} alt="arrow-right-operator" />
      </div>
    </div>
  );
};

export default HomeSelect;
